import TipOfTheWeek from './TipOfTheWeek';

export default TipOfTheWeek;
